var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTikTok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 7.311C18.7982 7.3128 18.0124 7.086 17.3323 6.6594C17.3484 6.6774 17.3645 6.6954 17.3824 6.7134C17.3663 6.6954 17.3502 6.6774 17.3323 6.6594C16.3193 6.024 15.589 4.9764 15.376 3.7488C15.3564 3.6318 15.3402 3.513 15.3295 3.3942V3H12.2457V15.3048C12.2403 16.7394 11.0823 17.9004 9.65402 17.9004C9.2352 17.9004 8.83786 17.7996 8.48885 17.6232C7.64406 17.1948 7.06416 16.3128 7.06416 15.2958C7.06416 13.8576 8.22396 12.6912 9.6558 12.6912C9.92965 12.6912 10.1945 12.7344 10.4415 12.8136V10.362V9.6636C10.1838 9.6276 9.92428 9.6096 9.66475 9.6114C6.53616 9.6114 4 12.1602 4 15.3066C4 17.2776 4.99693 19.0146 6.51111 20.037C7.41317 20.6454 8.4978 21 9.66475 21C12.7933 21 15.3295 18.4512 15.3295 15.3048V9.0174C16.5341 9.8832 18.0089 10.3908 19.6 10.3908",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.0452752a.svg";
export { ForwardRef as ReactComponent };